export default (value) => {
  if (!value && value !== 0) return value;
  return `VPC: ${value
    .toFixed(2)
    .replace('.', ',')
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.')} KM`;
};
